export default "__VITE_ASSET__ec6eeedf__"